'use strict';

(function () {
  if (!customElements.get('slideshow-banner')) {
    const BREAKPOINTS = {
      sm: 750,
      lg: 990,
    };

    class SlideshowBanner extends HTMLElement {
      constructor() {
        super();
        this.swiper = null;
        this._initialized = false;
      }

      connectedCallback() {
        this.pagination = this.querySelector('.swiper-pagination');
        const slides = this.querySelectorAll('.swiper-slide');
        if (slides.length <= 1) return;

        const bootSwiper = () => {
          if (this._initialized) return;
          this._initialized = true;
          ['touchstart', 'pointerdown', 'mousemove', 'keydown', 'wheel', 'scroll'].forEach((evt) => {
            window.removeEventListener(evt, bootSwiper, { passive: true });
          });
          this.hydrateDeferredImages();
          requestAnimationFrame(() => this.initSwiper());
        };

        ['touchstart', 'pointerdown', 'mousemove', 'keydown', 'wheel', 'scroll'].forEach((evt) => {
          window.addEventListener(evt, bootSwiper, { once: true, passive: true });
        });
      }

      hydrateDeferredImages() {
        this.querySelectorAll('img.js-deferred-slide-img').forEach((img) => {
          if (img.dataset.srcset) {
            img.srcset = img.dataset.srcset;
            img.removeAttribute('data-srcset');
          }
          if (img.dataset.src) {
            img.src = img.dataset.src;
            img.removeAttribute('data-src');
          }
        });
      }

      initSwiper = () => {
        if (this.swiper) return;
        this.hydrateDeferredImages();
        const slides = this.querySelectorAll('.swiper-slide');
        const slidesLength = slides.length;
        let { slidesPerView = 1, slidesPerViewSm, slidesPerViewLg, effect, speed, autoplay, loop = 'false', spaceBetween, spaceBetweenPc } = this.dataset;
        if (!slidesPerViewSm) slidesPerViewSm = slidesPerView;
        if (!slidesPerViewLg) slidesPerViewLg = slidesPerView;

        slidesPerView = slidesLength < +slidesPerView ? slidesLength : +slidesPerView;
        slidesPerViewSm = slidesLength < +slidesPerViewSm ? slidesLength : +slidesPerViewSm;
        slidesPerViewLg = slidesLength < +slidesPerViewLg ? slidesLength : +slidesPerViewLg;

        speed = (+speed || 5) * 1000;

        if (autoplay == 'true') {
          autoplay = {
            delay: speed,
            disableOnInteraction: false,
          };
        } else {
          autoplay = false;
        }

        let pagination = false;
        loop = loop == 'false' ? false : true;

        if (this.pagination) {
          pagination = {
            el: this.pagination,
            clickable: true,
            type: 'bullets',
          };
        }

        const swiperParams = {
          autoplay,
          slidesPerView,
          pagination,
          grabCursor: true,
          effect,
          centeredSlides: true,
          loop: loop,
          spaceBetween,
          breakpoints: {
            [BREAKPOINTS.sm]: {
              slidesPerView: slidesPerViewSm,
              spaceBetween: spaceBetweenPc,
            },
            [BREAKPOINTS.lg]: {
              slidesPerView: slidesPerViewLg,
              spaceBetween: spaceBetweenPc,
            },
          },
        };

        this.swiper = new Swiper(this, swiperParams);
      };
    }

    customElements.define('slideshow-banner', SlideshowBanner);
  }
})();
